export const userAr = {
  "Nom d'utilisateur Deja existe": "اسم المستخدم موجود بالفعل",
  "Nom d'utilisateur est obligatoire": "اسم المستخدم مطلوب",
  "Mot de passe est obligatoire": "كلمة المرور مطلوبة",
  "Numero de telephone est obligatoire": "رقم الهاتف مطلوب",
  "Donner au moins un role": "أعطي دورا واحدا على الأقل",
}
